import {TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  { id: 'contact_has_disclosed_bankrupt', name: 'contact_has_disclosed_bankrupt' },
  { id: 'contact_has_disclosed_bond', name: 'contact_has_disclosed_bond' },
  { id: 'contact_has_disclosed_civil_event', name: 'contact_has_disclosed_civil_event' },
  { id: 'contact_has_disclosed_criminal', name: 'contact_has_disclosed_criminal' },
  { id: 'contact_has_disclosed_customer_dispute', name: 'contact_has_disclosed_customer_dispute' },
  { id: 'contact_has_disclosed_investigation', name: 'contact_has_disclosed_investigation' },
  { id: 'contact_has_disclosed_judgment_or_lien', name: 'contact_has_disclosed_judgment_or_lien' },
  { id: 'contact_has_disclosed_regulatory_event', name: 'contact_has_disclosed_regulatory_event' },
  { id: 'contact_has_disclosed_termination', name: 'contact_has_disclosed_termination' },
]

const DisclosuresRow = (props) => {
  const {disclosure} = props;
  const classes = useStyles();

  return (
    keys.map(((key, index) =>
        <TableRow hover key={`${key.id}-${index}`}>
          <TableCell className={classes.inheritFontWeight}>{key.name}</TableCell>
          <TableCell key={`${key.name}-${index}`} className={classes.inheritFontWeight}>
            {_.isNil(disclosure[key.id]) ? '' : `${disclosure[key.id] == true ? 'Yes' : 'No'}`}
          </TableCell>
        </TableRow>
    ))
  )
}

export default DisclosuresRow;